import React, { useState, useEffect } from "react";
import { IParagraphVideoBlockProps } from "./ParagraphVideoBlockProps";
import { Styledcontainer } from "./ParagraphVideoBlockHelpers";
import { graphql } from "gatsby";
import VideoPlayer from "../../common/VideoPlayer/VideoPlayer";

const ParagraphVideoBlock: React.FC<IParagraphVideoBlockProps> = (props) => {
  const [isTargetcookiesActive, setIsTargetcookiesActive] = useState(
    typeof window !== "undefined" &&
      window?.OnetrustActiveGroups?.includes("C0004")
      ? true
      : false
  );

  useEffect(() => {
    const handleOneTrustGroupsUpdated = (event) => {
      if (event.detail.indexOf("C0004") > -1) {
        setIsTargetcookiesActive(true);
      } else {
        setIsTargetcookiesActive(false);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener(
        "OneTrustGroupsUpdated",
        handleOneTrustGroupsUpdated
      );
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener(
          "OneTrustGroupsUpdated",
          handleOneTrustGroupsUpdated
        );
      }
    };
  }, []);

  return isTargetcookiesActive ? (
    <Styledcontainer>
      <VideoPlayer url={props?.node?.field_link?.url} />
    </Styledcontainer>
  ) : null;
};

export const fragment = graphql`
  fragment ParagraphVideoBlock on paragraph__video_block {
    id
    field_link {
      url
    }
  }
`;

export default ParagraphVideoBlock;
